import { Component, EventEmitter, Input, Output,
    ChangeDetectionStrategy
} from '@angular/core';
import { Utils } from 'src/modules/utils/shared/utils';
import { TreeIcon } from '../../models/tree-icon.model';

@Component({
    selector: 'tree-item-with-icons',
    templateUrl: './tree-item-with-icons.component.html',
    styleUrls: ['./tree-item-with-icons.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TreeItemWithIconsComponent {

    _Utils = Utils;

    @Input()
    label = "";
    @Input()
    icons: TreeIcon[] = [];

    @Output()
    onClickIcon = new EventEmitter<TreeIcon>();

    click(icon: TreeIcon, event: MouseEvent): void {
      if (icon.clickable && this.onClickIcon != null) {
        event.stopPropagation();
        this.onClickIcon.emit(icon);
      }
    }
}
